import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LocaleProvider } from "@/i18n";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PublicBookingPage from "@/pages/PublicBookingPage";
import BarberPanel from "@/pages/BarberPanel";
import SuperAdminPage from "@/pages/SuperAdminPage";
import SuperAdminBarberEdit from "@/pages/SuperAdminBarberEdit";
import PartnerPage from "@/pages/PartnerPage";
import PaymentResult from "@/pages/PaymentResult";
import ChangePasswordPage from "@/pages/ChangePasswordPage";

function App() {
  return (
    <LocaleProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/:lang" element={<LandingPage />} />
          <Route path="/entrar" element={<LoginPage />} />
          <Route path="/:lang/entrar" element={<LoginPage />} />
          <Route path="/cadastro" element={<RegisterPage />} />
          <Route path="/:lang/cadastro" element={<RegisterPage />} />
          <Route path="/b/:slug" element={<PublicBookingPage />} />
          <Route path="/painel" element={<BarberPanel />} />
          <Route path="/admin" element={<SuperAdminPage />} />
          <Route path="/admin/barbearia/:id" element={<SuperAdminBarberEdit />} />
          <Route path="/socio" element={<PartnerPage />} />
          <Route path="/socio/barbearia/:id" element={<SuperAdminBarberEdit backTo="/socio" />} />
          <Route path="/pagamento/sucesso" element={<PaymentResult success />} />
          <Route path="/pagamento/cancelado" element={<PaymentResult />} />
          <Route path="/trocar-senha" element={<ChangePasswordPage />} />
          <Route path="/:lang/trocar-senha" element={<ChangePasswordPage />} />
        </Routes>
      </BrowserRouter>
    </LocaleProvider>
  );
}

export default App;
